function getField(template, fieldID) {
    return template.fields.find((f) => f.id === fieldID);
}
export const FormTemplateUtils = {
    getField,
};
